import {
    createContext,
    useContext,
    useEffect
} from "react";
import type {
    CodeViewerCopyContextType,
    CodeViewerContextType,
    CodeViewerPartKind
} from "./type";
import {
    warnOnce
} from "../../utils/development";

export const CODE_VIEWER_PART_NAMES: Record<CodeViewerPartKind, string> = {
    actions: "Actions",
    footer: "Footer",
    header: "Header",
    title: "Title"
};

export const CodeViewerCopyContext = createContext<CodeViewerCopyContextType>({
    shownCopyStatus: "copied",
    isTransitioned: false
});

export const CodeViewerContext = createContext<CodeViewerContextType | undefined>(undefined);

export const useCodeViewerCopyContext = (): CodeViewerCopyContextType => {
    return useContext(CodeViewerCopyContext);
};

export const useCodeViewerContext = ({
    part
}: {
    part: CodeViewerPartKind;
}): CodeViewerContextType | undefined => {
    const context = useContext(CodeViewerContext);

    useEffect(() => {
        if(context) {
            return;
        }

        warnOnce({
            message: `CodeViewer.${CODE_VIEWER_PART_NAMES[part]}: must be rendered inside <CodeViewer>.`
        });
    }, [
        context,
        part
    ]);

    return context;
};
